import * as yup from 'yup';
import { getText } from '@storebrand-digital/fms-translations';

export const periodFormValidationSchema = yup.object().shape(
  {
    createdFromDate: yup.date().when(['createdToDate'], {
      is: (date: Date | undefined) => !date,
      then: () =>
        yup
          .date()
          .nullable()
          .typeError(getText('dateRange.validation.typeError')),
      otherwise: () =>
        yup
          .date()
          .nullable()
          .typeError(getText('dateRange.validation.typeError'))
          .max(yup.ref('createdToDate'), getText('dateRange.validation.after')),
    }),
    createdToDate: yup.date().when(['createdFromDate'], {
      is: (date: Date | undefined) => !date,
      then: () =>
        yup
          .date()
          .nullable()
          .typeError(getText('dateRange.validation.typeError')),
      otherwise: () =>
        yup
          .date()
          .nullable()
          .typeError(getText('dateRange.validation.typeError'))
          .min(
            yup.ref('createdFromDate'),
            getText('dateRange.validation.before')
          ),
    }),
  },
  [['createdFromDate', 'createdToDate']]
);
